/*
 * **Le jour et l'heure d'un instant, là où vit l'utilisateur** (chantier nettoyage-mcp,
 * ticket 04) : écrits une fois, pour que le serveur et le MCP disent toujours le même jour d'un
 * rendez-vous et le même « aujourd'hui ». Un rendez-vous à 0 h 30 à Paris tombe à son jour, jamais
 * la veille comme le donnerait son jour en temps universel.
 *
 * Sans dépendance : `Intl` ne lit ni base ni réseau, seulement les règles des fuseaux embarquées
 * (heure d'été comprise). L'entrée « . » du paquet, l'app peut l'importer.
 */
/** Un nom de fuseau IANA connu (« Europe/Paris »). Une valeur absente, vide ou inconnue ne l'est pas. */
export function fuseauValide(fuseau) {
    if (!fuseau || fuseau.length > 64)
        return false;
    try {
        new Intl.DateTimeFormat('en-CA', { timeZone: fuseau });
        return true;
    }
    catch {
        return false;
    }
}
/**
 * Le jour « aaaa-mm-jj » et l'heure « hh:mm » (de 00:00 à 23:59) d'un instant dans ce fuseau.
 * Le fuseau doit être connu (`fuseauValide`) : un fuseau inconnu lève une `RangeError`, chacun
 * choisit son repli (le serveur prend le sien, le MCP refuse de compter).
 */
export function momentDansUnFuseau(instant, fuseau) {
    const parts = new Intl.DateTimeFormat('en-CA', {
        timeZone: fuseau,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hourCycle: 'h23',
    }).formatToParts(instant);
    const part = (type) => parts.find((p) => p.type === type)?.value ?? '00';
    return { jour: `${part('year')}-${part('month')}-${part('day')}`, heure: `${part('hour')}:${part('minute')}` };
}
